import React from 'react'
import { useTranslate } from '../TranslationText'
import NewActionButton from '../ActionButtons/NewActionButton';
import { eformFormButton } from '../../common/cssclasses';

export default function RejectBtn({ spanText, isDisabled, disabled, ...props }) {
    const { translate } = useTranslate();
    return (
        <div className={eformFormButton}>
            <NewActionButton
                isSubmitBtn
                isWithClass
                classNames={"btn-danger"}
                text={
                    <>
                        <i className="fa-solid fa-ban"></i>
                        {translate("web.reject", "Reject")}
                    </>
                }
                disabled={isDisabled ?? disabled ?? false}
                {...props}
            />
            {!!spanText &&
                <span>
                    {spanText}
                </span>
            }
        </div>
    )
}
